import { getAuthToken, removeAuthToken, removeAuthUser } from "../token";
import HttpError from "../HttpError";

export const getApi = async ({ apiUrl, sendToken = true, logout }) => {
  let headers = {
    "Content-Type": "application/json",
  };

  if (sendToken) {
    headers["x-access-token"] = getAuthToken();
  }

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}${apiUrl}`, {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      const { message } = await response.json();
      if (response.status === 401) {
        removeAuthToken();
        removeAuthUser();
        logout(null);
        throw new HttpError(401, message || "unauthorized user");
      } else {
        throw new HttpError(response.status, message || "something went wrong");
      }
    }
    return await response.json();
  } catch (error) {
    throw new HttpError(
      error?.status || 500,
      error?.message || "something went wrong"
    );
  }
};

export const postApi = async (
  { apiUrl, sendToken = true, data = {}, logout }
) => {
  let headers = {
    "Content-Type": "application/json",
  };

  if (sendToken) {
    headers["x-access-token"] = getAuthToken();
  }

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}${apiUrl}`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const { message } = await response.json();
      if (response.status === 401) {
        removeAuthToken();
        removeAuthUser();
        logout(null);
        throw new HttpError(401, message || "unauthorized user");
      } else {
        throw new HttpError(response.status, message || "something went wrong");
      }
    }
    return await response.json();
  } catch (error) {
    throw new HttpError(
      error?.status || 500,
      error?.message || "something went wrong"
    );
  }
};

export const putApi = async (
  { apiUrl, sendToken = true, data = {}, logout }
) => {
  let headers = {
    "Content-Type": "application/json",
  };

  if (sendToken) {
    headers["x-access-token"] = getAuthToken();
  }

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}${apiUrl}`, {
      method: "PUT",
      headers,
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const { message } = await response.json();
      if (response.status === 401) {
        removeAuthToken();
        removeAuthUser();
        logout(null);
        throw new HttpError(401, message || "unauthorized user");
      } else {
        throw new HttpError(response.status, message || "something went wrong");
      }
    }
    return await response.json();
  } catch (error) {
    throw new HttpError(
      error?.status || 500,
      error?.message || "something went wrong"
    );
  }
};

export const deleteApi = async (
  { apiUrl, sendToken = true, data = {}, logout }
) => {
  let headers = {
    "Content-Type": "application/json",
  };

  if (sendToken) {
    headers["x-access-token"] = getAuthToken();
  }

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}${apiUrl}`, {
      method: "DELETE",
      headers,
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const { message } = await response.json();
      if (response.status === 401) {
        removeAuthToken();
        removeAuthUser();
        logout(null);
        throw new HttpError(401, message || "unauthorized user");
      } else {
        throw new HttpError(response.status, message || "something went wrong");
      }
    }
    return await response.json();
  } catch (error) {
    throw new HttpError(
      error?.status || 500,
      error?.message || "something went wrong"
    );
  }
};
